import React, { Component } from "react";

import { hashHistory } from "react-router";
import { Modal, Header, Input, Table, Divider } from "semantic-ui-react";

class WodSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billinginfo: null,
      wod: null,
      resultdrop: "",
      searchVal: "",
      filteroptions: [],
      results: props.workorders,
      showModal: props.showWodSearch,
      datatype: "",
      resultkey: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log(this.props.workorders);
    console.log(this.state.searchVal);
    if (
      this.props.showModal &&
      this.props.workorders &&
      !this.state.results.length
    ) {
      this.genresults({ wodparam: "workOrderNbr", service: null });
      this.setState({ results: this.props.workorders });
    }
  }
  getwod(value) {
    if (value) {
      if (value[this.state.wodparam]) {
        this.setState({
          results: this.props.workorders.filter(
            wod => wod[this.state.wodparam] === value[this.state.wodparam]
          )
        });
      } else {
        this.setState({
          results: this.props.workorders.filter(
            wod => wod[this.state.wodparam] === value
          )
        });
      }
    }
  }
  genresults() {
    if (this.state.searchVal && this.state.searchVal.length) {
      var searchVal = this.state.searchVal.toLowerCase();
      return this.props.workorders.filter(
        wod =>
          wod.workOrderNbr.toLowerCase().includes(searchVal) ||
          wod.contactName.toLowerCase().includes(searchVal) ||
          wod.poNbr.toLowerCase().includes(searchVal) ||
          wod.description.toLowerCase().includes(searchVal) ||
          (wod.acctNbr && wod.acctNbr.toLowerCase().includes(searchVal))
      );
    } else {
      return this.props.workorders;
    }
  }
  genresultrows() {
    var results = this.genresults();
    return results.map(wod => {
      return (
        <Table.Row
          onClick={() => {
            hashHistory.push("/work-orders/" + wod.workOrderNbr);
            // window.location.reload();
          }}
        >
          <Table.Cell>{wod.workOrderNbr}</Table.Cell>
          <Table.Cell>{wod.description}</Table.Cell>
          <Table.Cell>{wod.program}</Table.Cell>
        </Table.Row>
      );
    });
  }
  genresulttable() {
    if (this.props.workorders.length > 0) {
      return (
        <Table celled selectable compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Number</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Program</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.genresultrows()}</Table.Body>
        </Table>
      );
    }
  }

  render() {
    return (
      <div className="WodSearchModal">
        <Modal
          open={this.props.showModal}
          basic
          onClose={() => {
            this.props.handleclose();
            this.setState(
              { results: this.props.workorders, filteroptions: [] },
              () => this.genresults({ wodparam: "workOrderNbr", service: null })
            );
          }}
        >
          <Header>Find Workorder</Header>
          <Modal.Content>
            <Input
              fluid
              label="Search Workorders"
              value={this.state.searchVal}
              onChange={e => this.setState({ searchVal: e.target.value })}
            />
            <Divider />

            {this.genresulttable()}
          </Modal.Content>
          <Modal.Actions />
        </Modal>
      </div>
    );
  }
}

export default WodSearchModal;



// WEBPACK FOOTER //
// ./src/components/wod/wodsearchmodal.js